import { render, staticRenderFns } from "./ProjectsDurationTrend.vue?vue&type=template&id=417fbf91&"
import script from "./ProjectsDurationTrend.vue?vue&type=script&lang=js&"
export * from "./ProjectsDurationTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports